export default {
  title: 'Flottakezelés',
  subtitle: 'Járművek kezelése és nyomon követése',
  
  // List view
  list: {
    addVehicle: 'Új jármű',
    firstVehicle: 'Első jármű hozzáadása',
    noVehicles: 'Nincs jármű',
    noResults: 'Nincs a keresésnek megfelelő jármű',
    startAdding: 'Kezdj el járműveket hozzáadni a flottához',
    resultsCount: 'jármű találat',
    search: 'Keresés rendszám, márka, modell vagy tulajdonos alapján...',
    allStatuses: 'Összes státusz',
  },

  // Table columns
  columns: {
    licensePlate: 'Rendszám',
    vehicle: 'Jármű',
    mileage: 'Km óra',
    owner: 'Tulajdonos',
    status: 'Státusz',
    actions: 'Műveletek',
  },

  // Actions
  actions: {
    view: 'Részletek',
    edit: 'Szerkesztés',
    delete: 'Törlés',
    confirmDelete: 'Biztosan törölni szeretnéd a(z) {{licensePlate}} rendszámú járművet?',
  },

  // Status
  status: {
    active: 'Aktív',
    inactive: 'Inaktív',
    maintenance: 'Karbantartás',
    sold: 'Eladva',
  },

  // Form
  form: {
    titleNew: 'Új jármű',
    titleEdit: 'Jármű szerkesztése',
    
    // Sections
    sections: {
      basicInfo: 'Alapadatok',
      technicalData: 'Műszaki adatok',
    },

    // Fields
    fields: {
      licensePlate: 'Rendszám',
      licensePlatePlaceholder: 'ABC-123',
      status: 'Státusz',
      make: 'Márka',
      makePlaceholder: 'Toyota, BMW, Mercedes...',
      model: 'Modell',
      modelPlaceholder: 'Corolla, X5, E-Class...',
      year: 'Gyártási év',
      fuelType: 'Üzemanyag',
      mileage: 'Km óra állás (opcionális)',
      mileagePlaceholder: 'Később is rögzíthető',
      mileageHelp: 'A km óra állást később is rögzítheted szerviz vagy költség felvitelekor',
      color: 'Szín',
      colorPlaceholder: 'Fekete, Fehér, Piros...',
      vin: 'Alvázszám (VIN)',
      vinPlaceholder: 'WVWZZZ1JZXW123456',
      registrationNumber: 'Forgalmi engedély száma',
      registrationNumberPlaceholder: 'AB-123456',
      vehicleLogbookNumber: 'Törzskönyv száma',
      vehicleLogbookNumberPlaceholder: '123456',
      ownerOrganization: 'Tulajdonos szervezet',
      ownerOrganizationHelp: 'Válassz egy szervezetet a CRM-ből',
      ownerOrganizationNone: '-- Nincs kiválasztva --',
      ownerName: 'Tulajdonos neve (ha nem CRM ügyfél)',
      ownerNamePlaceholder: 'Tulajdonos teljes neve',
      ownerNameHelp: 'Ha a tulajdonos nem a CRM szervezet',
      engineCapacity: 'Hengerűrtartalom (cm³)',
      power: 'Teljesítmény (kW)',
      seats: 'Ülések száma',
      hasTowbar: 'Vonóhorog',
      purchasePrice: 'Vásárlási ár (HUF)',
      notes: 'Megjegyzések',
    },

    // Fuel types
    fuelTypes: {
      gasoline: 'Benzin',
      diesel: 'Dízel',
      electric: 'Elektromos',
      hybrid: 'Hibrid',
      lpg: 'LPG',
      cng: 'CNG',
    },

    // Buttons
    buttons: {
      cancel: 'Mégse',
      save: 'Mentés...',
      create: 'Létrehozás',
      update: 'Frissítés',
    },
  },

  // Messages
  messages: {
    created: 'Jármű létrehozva',
    updated: 'Jármű frissítve',
    deleted: 'Jármű törölve',
    error: 'Hiba',
    deleteWarning: 'Ez a művelet nem visszavonható.',
  },
};
